import React from 'react'
import classNames from 'classnames'

const VoiceGrid = ({ className = '', view = 'GRID', ...props }) => (
  <div
    {...props}
    className={classNames('w-full',
      {
        GRID: 'grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6',
        LIST: 'grid grid-cols-1 gap-6',
        MASONRY: 'gap-6 columns-1 sm:columns-2 xl:columns-3 space-y-6',
      }[view],
      className,
    )}
  />
)

export default VoiceGrid
